import React from "react";
import styled from "styled-components";
import { colorAttentionBlue50, colorFunctionalWhite, fontSizeS, spacingM, spacingS, spacingXs, } from "@rhumbix/rmbx_design_system_design_tokens";
const Badge = ({ badgeColor = colorAttentionBlue50, className = "", height = 16, text, textColor = colorFunctionalWhite, width = 80, }) => {
    return (React.createElement(BadgeContainer, { color: badgeColor, width: width, height: height, className: className },
        React.createElement(BadgeText, { color: textColor }, text)));
};
const BadgeContainer = styled.div `
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: ${spacingXs} ${spacingS};

    width: ${props => props.width}px;
    height: ${props => props.height}px;
    background: ${props => props.color};
    border-radius: ${spacingM};
`;
const BadgeText = styled.text `
    color: ${props => props.color};
    font-weight: 700;
    font-size: ${fontSizeS};
`;
export default Badge;
